<template>
  <div class="day-plan-container">
    <div>
      <div class="day-plan-header">
        <div class="info-field">
          <van-field
            readonly
            clickable
            name="calendar"
            :value="planTime"
            placeholder="点击选择日期"
            @click="showCalendar = true"
          >
            <template #right-icon>
              <img class="icon-calendar" src="@/assets/imgs/calendar.png" alt />
            </template>
          </van-field>
          <van-calendar
            v-model="showCalendar"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onCalendarConfirm"
            :show-confirm="false"
            poppable
            get-container="body"
          />
          <van-field
            readonly
            clickable
            name="picker"
            :value="seller.salesUnitName"
            placeholder="选择销售公司"
            @click="showPicker = true"
          >
            <template #right-icon>
              <img
                class="icon-select-arrow"
                src="@/assets/imgs/select-arrow.png"
                alt
              />
            </template>
          </van-field>
        </div>
        <div class="info-line">
          <div class="info-label">销售公司：</div>
          <div class="info-value">{{ seller.salesUnitName }}</div>
          <span v-if="showStatus" class="info-status">{{
            planInfo.statusName
          }}</span>
        </div>
        <div class="info-line">
          <div class="info-label">计划日期：</div>
          <div class="info-value">{{ planTime }} 08:00 至次日 08:00</div>
        </div>
        <div class="info-line">
          <div class="info-label">客户名称：</div>
          <div class="info-input">
            <van-field
              readonly
              clickable
              name="picker"
              :value="crmInfo.crmName"
              placeholder="选择客户名称"
              @click="showCrmPicker = true"
            >
              <template #right-icon>
                <img
                  class="icon-select-arrow"
                  src="@/assets/imgs/select-arrow.png"
                  alt
                />
              </template>
            </van-field>
          </div>
        </div>
        <div class="info-line">
          <div class="info-label">审批通知：</div>
          <div class="info-input">
            <van-field
              v-model="planInfo.telephones"
              placeholder="请输入通知手机号，多个请用英文逗号隔开"
              :disabled="disabledSubmited"
            ></van-field>
          </div>
        </div>
      </div>
      <div class="card-wrap">
        <div
          class="day-plan-card"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <van-collapse v-model="activeTerminal">
            <van-collapse-item :name="item.terminalCode">
              <template #title>
                <div class="title-name">管线：{{ item.pipelineName }}</div>
                <div class="title-name">场站：{{ item.terminalName }}</div>
              </template>
              <div class="content" v-if="planInfo.status == '10'">
                <!-- <div class="content-line">
                  <div class="content-line-label">月计划日均量（万方）:</div>
                  <div class="content-line-value">
                    {{ item.monthPlanAvgVolume }}
                  </div>
                </div> -->
                <div class="content-line">
                  <div class="content-line-label">当月日均用气量（万方）:</div>
                  <div class="content-line-value">
                    {{ item.monthUsedAvgVolume }}
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">日需求量（万方）:</div>
                  <div class="content-line-value">
                    <van-field
                      class="content-line-field"
                      v-model="item.dayVolume"
                      type="number"
                      v-reset-page
                      :formatter="formatterDayVolume"
                      :disabled="disabledSubmited"
                    ></van-field>
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">提报备注 :</div>
                  <div class="content-line-value">
                    <van-field
                      class="content-line-field"
                      v-model="item.remark"
                      type="text"
                      v-reset-page
                      :disabled="disabledSubmited"
                    ></van-field>
                  </div>
                </div>
              </div>
              <div v-else id="status-content">
                <!-- 待审核，审核中，已审核 -->
                <div
                  v-if="planInfo.status == '20' || planInfo.status == '30'"
                  class="content"
                >
                  <!-- <div class="content-line">
                    <div class="content-line-label">月计划日均量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.monthPlanAvgVolume | emptyFilter }}
                    </div>
                  </div> -->
                  <div class="content-line">
                    <div class="content-line-label">日需求量（万方）:</div>
                    <div class="content-line-value">
                      <van-field
                        class="content-line-field"
                        v-model="item.originalRequireVolume"
                        type="number"
                        v-reset-page
                        :formatter="formatterDayVolume"
                        :disabled="disabledSubmited"
                      ></van-field>
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">批准量（万方）:</div>
                    <div class="content-line-value">
                      {{
                        item.confirmVolume
                          ? item.confirmVolume
                          : item.originalConfirmVolume | emptyFilter
                      }}
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">提报备注 :</div>
                    <div class="content-line-value">
                      <van-field
                        class="content-line-field"
                        v-reset-page
                        v-model="item.originalRemark"
                        :disabled="disabledSubmited"
                      ></van-field>
                    </div>
                  </div>
                </div>
                <!-- 已审核 -->
                <div v-if="planInfo.status == '40'" class="content">
                  <!-- <div class="content-line">
                    <div class="content-line-label">月计划日均量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.monthPlanAvgVolume | emptyFilter }}
                    </div>
                  </div> -->
                  <div class="content-line">
                    <div class="content-line-label">日需求量（万方）:</div>
                    <div class="content-line-value">
                      <van-field
                        class="content-line-field"
                        v-model="item.originalRequireVolume"
                        :formatter="formatterDayVolume"
                        type="number"
                        v-reset-page
                        :disabled="disabledSubmited"
                      ></van-field>
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">批准量（万方）:</div>
                    <div class="content-line-value">
                      {{
                        item.confirmVolume
                          ? item.confirmVolume
                          : item.originalConfirmVolume | emptyFilter
                      }}
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">提报备注 :</div>
                    <div class="content-line-value">
                      <van-field
                        v-reset-page
                        class="content-line-field"
                        v-model="item.originalRemark"
                        :disabled="disabledSubmited"
                      ></van-field>
                    </div>
                  </div>
                  <!-- 已审核 -->
                  <div
                    v-if="planInfo.status == '30' || planInfo.status == '40'"
                    class="content-line"
                  >
                    <div class="content-line-label">批复备注 :</div>
                    <div class="content-line-value">
                      <div class="content-line-value">
                        {{ item.originalReviewRemark | emptyFilter }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 变更审核中 -->
                <div v-if="planInfo.status == '50'" class="content">
                  <!-- <div class="content-line">
                    <div class="content-line-label">月计划日均量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.monthPlanAvgVolume | emptyFilter }}
                    </div>
                  </div> -->
                  <div class="content-line">
                    <div class="content-line-label">初始需求量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.originalRequireVolume }}
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">变更需求量（万方）:</div>
                    <div class="content-line-value">
                      <van-field
                        class="content-line-field"
                        v-model="item.dayVolume"
                        type="number"
                        :formatter="formatterDayVolume"
                        :disabled="disabledSubmited"
                      ></van-field>
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">批准量（万方）:</div>
                    <div class="content-line-value">
                      {{
                        item.confirmVolume
                          ? item.confirmVolume
                          : item.originalConfirmVolume | emptyFilter
                      }}
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">变更备注 :</div>
                    <div class="content-line-value">
                      <van-field
                        class="content-line-field"
                        v-model="item.remark"
                        :disabled="disabledSubmited"
                      ></van-field>
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">变更批复备注 :</div>
                    <div class="content-line-value">
                      {{ item.reviewRemark | emptyFilter }}
                    </div>
                  </div>
                </div>
                <!-- 变更已通过，变更已关闭 -->
                <div
                  v-if="planInfo.status == '60' || planInfo.status == '70'"
                  class="content"
                >
                  <!-- <div class="content-line">
                    <div class="content-line-label">月计划日均量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.monthPlanAvgVolume | emptyFilter }}
                    </div>
                  </div> -->
                  <div class="content-line">
                    <div class="content-line-label">初始需求量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.originalRequireVolume }}
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">变更需求量（万方）:</div>
                    <div class="content-line-value">{{ item.dayVolume }}</div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">批准量（万方）:</div>
                    <div class="content-line-value">
                      {{
                        item.confirmVolume
                          ? item.confirmVolume
                          : item.originalConfirmVolume | emptyFilter
                      }}
                    </div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">变更备注 :</div>
                    <div class="content-line-value">{{ item.remark }}</div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">变更批复备注 :</div>
                    <div class="content-line-value">
                      {{ item.reviewRemark | emptyFilter }}
                    </div>
                  </div>
                </div>
                <!-- 执行中，已完成 -->
                <div
                  v-if="planInfo.status == '80' || planInfo.status == '90'"
                  class="content"
                >
                  <!-- <div class="content-line">
                    <div class="content-line-label">月计划日均量（万方）:</div>
                    <div class="content-line-value">
                      {{ item.monthPlanAvgVolume | emptyFilter }}
                    </div>
                  </div> -->
                  <div class="content-line">
                    <div v-if="item.dayVolume" class="content-line-label">
                      初始需求量（万方）:
                    </div>
                    <div v-else class="content-line-label">
                      日需求量（万方）:
                    </div>
                    <div class="content-line-value">
                      {{ item.originalRequireVolume }}
                    </div>
                  </div>
                  <div v-if="item.dayVolume" class="content-line">
                    <div class="content-line-label">变更需求量（万方）:</div>
                    <div class="content-line-value">{{ item.dayVolume }}</div>
                  </div>
                  <div class="content-line">
                    <div class="content-line-label">批准量（万方）:</div>
                    <div class="content-line-value">
                      {{
                        item.confirmVolume
                          ? item.confirmVolume
                          : item.originalConfirmVolume | emptyFilter
                      }}
                    </div>
                  </div>
                  <div v-if="planInfo.status == '90'" class="content-line">
                    <div class="content-line-label">完成量（万方）:</div>
                    <div class="content-line-value">
                      <!-- {{ item.quantityCompleted | emptyFilter }} -->
                      {{ item.completeVolume | emptyFilter }}
                    </div>
                  </div>
                  <div v-if="item.dayVolume">
                    <div class="content-line">
                      <div class="content-line-label">变更备注 :</div>
                      <div class="content-line-value">{{ item.remark }}</div>
                    </div>
                    <div class="content-line">
                      <div class="content-line-label">变更批复备注 :</div>
                      <div class="content-line-value">
                        {{ item.reviewRemark | emptyFilter }}
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="content-line">
                      <div class="content-line-label">提报备注 :</div>
                      <div class="content-line-value">{{ item.remark }}</div>
                    </div>
                    <div class="content-line">
                      <div class="content-line-label">提报批复备注 :</div>
                      <div class="content-line-value">
                        {{ item.reviewRemark | emptyFilter }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
    <div v-if="!disabledSubmited" class="btn-container">
      <div v-if="showSaveBtn" class="day-plan-btn-wrap">
        <!-- <van-button class="btn save" @click="handleSave">保存</van-button> -->
        <van-button class="btn" @click="handleSubmit">提交</van-button>
      </div>
      <div v-else class="day-plan-btn-wrap">
        <van-button class="btn large" @click="handleSubmit">提交</van-button>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        title="销售公司"
        :columns="sellerList"
        value-key="salesUnitName"
        @confirm="onSellerConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showCrmPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        title="客户名称"
        :columns="crmCustomerList"
        value-key="crmName"
        @confirm="onCrmMemberConfirm"
        @cancel="showCrmPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import pngApi from "@/request/pngApi.js";
export default {
  name: "PngDayPlanTabContent",
  props: {
    curTab: String,
  },
  data() {
    return {
      submited: false,
      showCalendar: false,
      showPicker: false,
      showCrmPicker: false,
      planTime: "",
      // minDate: new Date(),
      // maxDate: new Date(),
      seller: {},
      sellerList: [],
      crmInfo: {},
      crmCustomerList: [],
      activeTerminal: [],
      planInfo: {},
      dataList: [],
      supplyGasTypeList: ["100000000", "100000001"],
      // demandVolume:0
      // disabledSubmited: false,
      deadline: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    showStatus() {
      return this.planInfo.planDayId && this.planInfo.status;
    },
    showSaveBtn() {
      return !this.planInfo.planDayId || this.planInfo.status == "10";
    },
    disabledSubmited() {
      return this.planInfo.status != "10";
    },
    demandVolume() {
      let sum = this.dataList.reduce((prev, cur) => {
        return prev + parseFloat(cur.dayVolume);
      }, 0);
      return sum;
    },
    minDate() {
      let sDate =
        new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000; //第二天
      if (this.deadline) {
        sDate =
          this.deadline < Date.now()
            ? new Date(new Date(this.deadline).toLocaleDateString()).getTime() +
              2 * 24 * 60 * 60 * 1000
            : sDate;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.planTime = this.$utils.formatDate(sDate);
      console.log("sDate type is " + typeof sDate + ", value is " + sDate);
      return new Date(sDate);
    },
    maxDate() {
      let mDate = new Date(this.minDate);
      mDate = mDate.setDate(this.minDate.getDate() + 6);
      console.log(
        "minDate =====================" +
          new Date(this.minDate).toLocaleDateString()
      );
      console.log(
        "maxDate =====================" + new Date(mDate).toLocaleDateString()
      );
      return new Date(mDate);
    },
  },
  watch: {
    planTime: function (val) {
      this.planInfo = {};
      this.dataList = [];
      if (!val) {
        return;
      }
      if (
        this.planTime &&
        this.seller.salesUnitCode &&
        this.crmInfo.crmMember
      ) {
        this.initPlan();
      }
    },
    seller: {
      handler(val) {
        if (!val) {
          return;
        }
        this.listCrmCustomer(val.salesUnitCode);
      },
      deep: true,
    },
    crmInfo: {
      handler(val) {
        if (!val) {
          return;
        }
        if (
          this.planTime &&
          this.seller.salesUnitCode &&
          this.crmInfo.crmMember
        ) {
          this.initPlan();
        }
      },
      deep: true,
    },
  },
  // created() {
  //   let curDate = new Date();
  //   curDate.setDate(curDate.getDate() + 1);
  //   this.planTime = this.$utils.formatDate(curDate);
  //   this.minDate = curDate;
  //   this.maxDate.setDate(this.minDate.getDate() + 6);
  // },
  mounted() {
    this.getSellerList();
    this.getDayDeadline(); //获取明日计划提报截止时间
  },
  methods: {
    //获取计划提报截止时间
    getDayDeadline() {
      pngApi.getDayDeadline().then((res) => {
        if (res.returnCode === "0") {
          this.deadline = res.result;
          console.log("Today plan deadline is " + this.deadline);
        } else {
          this.$toast({
            message: res.returnMessage,
          });
        }
      });
    },
    formatterDayVolume(value) {
      return this.$utils.poidNumber(value);
    },
    handleSave() {
      if (!this.planTime) {
        this.$toast({
          message: "请选择计划时间",
        });
        return;
      }
      if (!this.seller.salesUnitCode) {
        this.$toast({
          message: "请选择销售公司",
        });
        return;
      }
      if (!this.crmInfo.crmMember) {
        this.$toast({
          message: "请选择客户名称",
        });
        return;
      }
      // if (!this.planInfo.telephones) {
      //   this.$toast({
      //     message: "请输入审批通知",
      //   });
      //   return;
      // }
      //保存日计划
      this.savePlan();
    },
    savePlan() {
      let params = Object.assign({}, this.planInfo);
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      params.crmMember = this.crmInfo.crmMember;
      params.crmName = this.crmInfo.crmName;
      params.supplyGasType = this.crmInfo.supplyGasType;
      params.supplyGasTypeName = this.crmInfo.supplyGasTypeName;
      params.planTime = this.$utils
        .formatDate(new Date(this.planTime))
        .replace(/-/g, "/");
      params.memberId = this.userInfo.companyAuthModel.companyId;
      params.memberCode = this.userInfo.companyAuthModel.companyMdm;
      params.memberName = this.userInfo.companyAuthModel.companyName;
      params.materialCode = this.$common.interfacePath.PngMaterialCode; //物料编码
      params.pngPlanDayDetailVoList = this.dataList.map((item) => {
        if (this.planInfo.planDayId) {
          let recordVO = item.pngPlanDaySubmitRecordVOList[0];
          recordVO.dayVolume = item.dayVolume;
          recordVO.remark = item.remark;
          item.pngPlanDaySubmitRecordVOList = [];
          item.pngPlanDaySubmitRecordVOList.push(recordVO);
        } else {
          item.pngPlanDaySubmitRecordVOList = [];
          item.pngPlanDaySubmitRecordVOList.push({
            dayVolume: item.dayVolume,
            remark: item.remark,
          });
        }
        return item;
      });
      // console.log(JSON.stringify(params));
      this.submited = true;
      //保存日计划
      pngApi.dayPlanSave(params).then((res) => {
        this.submited = false;
        if (res.returnCode === "0") {
          this.$dialog
            .alert({
              message: "保存成功",
            })
            .then(() => {
              this.initPlan();
            });
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    handleSubmit() {
      if (!this.planTime) {
        this.$toast({
          message: "请选择计划时间",
        });
        return;
      }
      if (!this.seller.salesUnitCode) {
        this.$toast({
          message: "请选择销售公司",
        });
        return;
      }
      if (!this.crmInfo.crmMember) {
        this.$toast({
          message: "请选择客户名称",
        });
        return;
      }
      // if (!this.planInfo.telephones) {
      //   this.$toast({
      //     message: "请输入审批通知",
      //   });
      //   return;
      // }
      //校验日需求量是否全部填写
      let tempList = this.dataList.filter((row) => {
        return (
          row.dayVolume == null ||
          row.dayVolume == "" ||
          row.dayVolume == undefined
        );
      });
      if (tempList.length > 0) {
        this.$toast({
          message: "请输入日需求量（万方）！",
        });
        return;
      }
      //校验余额
      // this.balanceCheck();
      this.submitPlan();
    },
    submitPlan() {
      let params = Object.assign({}, this.planInfo);
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      params.crmMember = this.crmInfo.crmMember;
      params.crmName = this.crmInfo.crmName;
      params.supplyGasType = this.crmInfo.supplyGasType;
      params.supplyGasTypeName = this.crmInfo.supplyGasTypeName;
      params.planTime = this.$utils
        .formatDate(new Date(this.planTime))
        .replace(/-/g, "/");
      params.memberId = this.userInfo.companyAuthModel.companyId;
      params.memberCode = this.userInfo.companyAuthModel.companyMdm;
      params.memberName = this.userInfo.companyAuthModel.companyName;
      params.materialCode = this.$common.interfacePath.PngMaterialCode; //物料编码
      params.dataFrom = "1";
      params.pngPlanDayDetailVoList = this.dataList.map((item) => {
        if (this.planInfo.planDayId) {
          let recordVO = item.pngPlanDaySubmitRecordVOList[0];
          recordVO.dayVolume = item.dayVolume;
          recordVO.remark = item.remark;
          item.pngPlanDaySubmitRecordVOList = [];
          item.pngPlanDaySubmitRecordVOList.push(recordVO);
        } else {
          item.pngPlanDaySubmitRecordVOList = [];
          item.pngPlanDaySubmitRecordVOList.push({
            dayVolume: item.dayVolume,
            remark: item.remark,
          });
        }
        return item;
      });
      // console.log(JSON.stringify(params));
      this.submited = true;
      //保存日计划
      pngApi.dayPlanSubmit(params).then((res) => {
        if (res.returnCode === "0") {
          this.$dialog
            .alert({
              message: "提报成功",
              // message: "提报成功，请到日指定查看中查看",
            })
            .then(() => {
              this.dataList = [];
              this.initPlan();
            });
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
          this.submited = false;
        }
      });
    },
    async balanceCheck() {
      let query = {};
      query.crmMember = this.crmInfo.crmMember;
      query.memberCode = this.userInfo.companyAuthModel.companyMdm;
      (query.sellerCode = this.seller.salesUnitCode),
        (query.planDay = this.$utils
          .formatDate(new Date(this.planTime))
          .replace(/-/g, "/"));
      query.originalVolume = this.demandVolume;
      pngApi.balanceCheck(query).then((res) => {
        if (res.returnCode === "0") {
          if (res.result.vaildResult === "1") {
            this.submitPlan();
          } else {
            this.$dialog
              .alert({
                title: "提示",
                message: "您的可用余额不足，请及时充值！",
              })
              .then(() => {
                this.submitPlan();
              });
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
          this.submited = false;
        }
      });
    },
    checkExists() {
      let params = {
        memberCode: this.userInfo.companyAuthModel.companyMdm,
        sellerCode: this.seller.salesUnitCode,
        crmMember: this.crmInfo.crmMember,
        planTime: this.$utils.formatDate(this.planTime).replace(/-/g, "/"),
      };
      pngApi.dayPlanExists(params).then((res) => {
        if (res.returnCode === "0") {
          if (res.result == false) {
            this.initPlan();
          } else {
            this.$dialog
              .alert({
                // message: "该销售公司的日计划已保存或已提交，请不要重复提交！",
                message: "该日指定已填报！",
              })
              .then(() => {
                // this.initPlan();
                // this.disabledSubmited = true;
              });
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //初始化计划列表
    dayPlanInit() {
      let params = {};
      params.sellerCode = this.seller.salesUnitCode;
      params.crmMember = this.crmInfo.crmMember;
      params.planTime = this.$utils
        .formatDate(this.planTime)
        .replace(/-/g, "/");
      pngApi.dayPlanInit(params).then((res) => {
        if (res.returnCode === "0") {
          this.planInfo = res.result;
          if (res.result.pngPlanDayDetailVoList) {
            this.dataList = res.result.pngPlanDayDetailVoList;
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    initPlan() {
      let params = {};
      params.sellerCode = this.seller.salesUnitCode;
      params.crmMember = this.crmInfo.crmMember;
      params.planTime = this.$utils
        .formatDate(this.planTime)
        .replace(/-/g, "/");
      params.pageNum = 1;
      params.pageSize = 100;
      pngApi.dayPlanPage(params).then((res) => {
        if (res.returnCode === "0") {
          if (res.result.dataList.length == 0) {
            //未提报
            this.dayPlanInit();
          } else {
            this.planInfo = res.result.dataList[0];
            if (this.planInfo.status != "10") {
              this.$dialog
                .alert({
                  message: "当前日指定已提报，请在日指定查看中查询！",
                })
                .then(() => {
                  return;
                });
              this.planInfo = {};
              // this.crmInfo = {}
            } else {
              if (this.planInfo.pngPlanDayDetailVoList) {
                this.dataList = this.planInfo.pngPlanDayDetailVoList.map(
                  (item) => {
                    item.dayVolume = item.dayVolume
                      ? item.dayVolume
                      : item.originalRequireVolume;
                    item.remark = item.remark
                      ? item.remark
                      : item.originalRemark;
                    return item;
                  }
                );
              }
            }
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //获取销售公司列表
    getSellerList() {
      let params = {
        supplyGasTypeList: this.supplyGasTypeList,
      };
      pngApi.pngListSeller(params).then((res) => {
        if (res.returnCode == "0") {
          this.sellerList = res.result;
          if (res.result.length == 1) {
            this.seller = res.result[0];
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    async listCrmCustomer(val) {
      let params = {
        orgCodeList: [val],
        supplyGasTypeList: this.supplyGasTypeList,
      };
      let { returnCode, returnMessage, result } = await pngApi.listCrmCustomer(
        params
      );
      if (returnCode === "0") {
        this.crmCustomerList = result;
        // if (result.length == 1) {
        //   this.crmInfo = result[0];
        // }
      } else {
        this.$toast({
          type: "fail",
          message: returnMessage,
          duration: 1500,
        });
      }
    },
    onCalendarConfirm(date) {
      this.planTime = this.$utils.formatDate(date);
      this.showCalendar = false;
      // if (date && this.seller.salesUnitCode && this.crmInfo.crmMember) {
      //   this.initPlan();
      // }
    },
    onSellerConfirm(value) {
      if (value) {
        this.seller = value;
      }
      this.showPicker = false;
    },
    onCrmMemberConfirm(value) {
      this.crmInfo = value;
      this.showCrmPicker = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl';

.day-plan-header >>> .van-cell {
  height: 64px;
  width: 342px;
  line-height: 64px;
  font-size: 28px;
  border: 1PX solid rgba(102, 102, 102, 1);
  border-radius: 10px;
  align-items: center;
}

.info-input >>> .van-cell {
  height: 54px;
  width: 100%;
  line-height: 54px;
  font-size: 24px;
  border: 1PX solid rgba(102, 102, 102, 1);
  border-radius: 10px;
  align-items: center;
}

.day-plan-header {
  background: $bgColor;
  padding: 24px 24px;

  .info-field {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
  }

  .info-line {
    position: relative;
    display: flex;
    font-size: 26px;
    line-height: 84px;
    align-items: center;

    .info-label {
      color: #393939;
      width: 200px;
      text-align: right;
    }

    .info-value {
      color: #666666;
      margin-left: 16px;
    }

    .info-input {
      flex: 1;
      display: inline-block;
      // width: 100%;
      color: #666666;
      margin-left: 16px;
    }

    .info-status {
      position: absolute;
      right: 4px;
      display: inline-block;
      // width: 102px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      font-size: 30px;
      color: rgba(225, 32, 32, 1);
      border: 1PX solid rgba(225, 32, 32, 1);
      border-radius: 4px;
      padding: 0 8px;
    }
  }
}

.icon-calendar {
  width: 42px;
  height: 37.26px;
}

.icon-select-arrow {
  width: 20px;
  height: 10px;
}

.day-plan-card >>> .van-cell {
  // height: 90px;
  height: 180px;
  padding: 24px 0;
  font-size: 30px;
  align-items: center;
}

.day-plan-card >>> .van-cell__title {
  // display: flex;
}

.day-plan-card >>> .van-cell__right-icon {
  font-size: 26px;
  color: #323233;
}

.day-plan-card >>>.van-collapse-item__content {
  padding: 24px 0;
  font-size: 26px;
  line-height: 90px;
}

.day-plan-container {
  // flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // overflow: auto;
  padding-bottom: 198px;

  .card-wrap {
    margin-top: 24px;

    .day-plan-card {
      background: $bgColor;
      padding: 0px 24px;

      .title-name {
        width: 100%;
        line-height: 72px;
      }

      .content {
        .content-line {
          display: flex;
          align-items: center;

          .content-line-label {
            width: 342px;
            text-align: right;
          }

          .content-line-value {
            width: 342px;
            margin-left: 18px;
            color: #333333;

            .content-line-field {
              height: 64px;
              border: 1PX solid #666666;
              border-radius: 10px;
              padding: 0.1rem 0.16rem;
            }
          }

          .font-red {
            color: #E12020;
          }
        }
      }
    }
  }

  .day-plan-btn-wrap {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 128px;
    // margin-top:20px;
    margin-bottom: 108px;
    padding: 0 24px;

    .btn {
      flex: 1;
      // width: 342px;
      height: 80px;
      background: linear-gradient(132deg, rgba(239, 150, 35, 1) 0%, rgba(225, 32, 32, 1) 100%);
      border-radius: 40px;
      font-size: 34px;
      line-height: 48px;
      color: rgba(255, 255, 255, 1);
    }

    .save {
      background: #ffffff;
      color: #E12020;
      border: 1PX solid rgba(225, 32, 32, 1);
      margin-right: 18px;
    }

    .large {
      width: 670px;
    }
  }
}

.icon-calendar {
  width: 42px;
  height: 37.26px;
}

.icon-select-arrow {
  width: 20px;
  height: 10px;
}

.icon-arrow-down {
  width: 20px;
  height: 10px;
  position: absolute;
  right: 19px;
}
</style>